import React, { Fragment, useState, useEffect, useContext } from "react";
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, Image, H6, P } from "../../AbstractElements";
import { megaLogo } from "../../api";
import { postForgotPassword, verifyOtp } from "../../Services/Auth.service";
import { useLocation, useNavigate } from "react-router";

const VerifyOtp = () => {
    const [otp, setOtp] = useState("");
    const [loading, setLoading] = useState(false);
    const [forgotPasswordRes, setForgotPasswordRes] = useState(() => {
        return {
            message: null,
            color: null,
        };
    });

    const location = useLocation()
    const navigate = useNavigate()

    const otpVerify = () => {
        if (!otp || otp.length < 4) {
            setForgotPasswordRes({
                message: "Incorrect OTP",
                color: "red",
            });
            return
        }
        let body = {
            mobile: location.state?.mobile ? Number(location.state?.mobile) : null,
            otp: otp ? Number(otp) : null
        }
        setLoading(true);
        verifyOtp(body)
            .then((result) => {
                setLoading(false);
                console.log(result);
                navigate(`/resetpassword/${result.data.resetKey}`)
            })
            .catch((err) => {
                setLoading(false);
                setForgotPasswordRes({
                    message: err.response?.data?.message
                        ? err.response.data.message
                        : "Something went wrong",
                    color: "red",
                });
            });
    };


    return (
        <Container fluid={true} className="p-0 login-page">
            <Row>
                <Col xs="12">
                    <div className="login-card">
                        <div className="login-main login-tab">
                            <Fragment>
                                <div className="theme-form">
                                    <Row className="customer-logo">
                                        <Image
                                            attrImage={{
                                                className: "img-fluid d-inline",
                                                src: megaLogo,
                                                alt: "",
                                            }}
                                        />
                                    </Row>
                                    <Col style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                        <H6>Verify Phone Number</H6>
                                        <P>
                                            We sent OTP to your phone number to verify your account
                                        </P>
                                    </Col>
                                    <FormGroup>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter OTP"
                                            maxLength={4}
                                            value={otp}
                                            pattern="[0-9]+"
                                            onChange={(e) => {
                                                setOtp(e.target.value.replace(/[^0-9]/g, ''))
                                            }}
                                        />
                                    </FormGroup>
                                    <div>
                                        {forgotPasswordRes.message ? (
                                            <span style={{ color: forgotPasswordRes.color }}>
                                                {forgotPasswordRes.message}
                                            </span>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                    <div className="position-relative form-group mb-0">
                                        <Btn
                                            attrBtn={{
                                                color: "primary",
                                                className: "d-block w-100 mt-2",
                                                disabled: loading ? loading : loading,
                                                onClick: (e) => otpVerify(),
                                            }}
                                        >
                                            {loading ? "LOADING..." : "Verify"}
                                        </Btn>
                                    </div>
                                </div>
                            </Fragment>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default VerifyOtp;
